"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useToast = exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

require("./notification.scss");

var _inlineNotification = _interopRequireDefault(require("./inlineNotification"));

var TOAST_TIMEOUT = 5000;

var ToastNotification = function ToastNotification(_ref) {
  var type = _ref.type,
      children = _ref.children,
      onClose = _ref.onClose;
  setTimeout(onClose, TOAST_TIMEOUT);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "nstyle-inline-notification--toast"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'animate-hidden'
  }, /*#__PURE__*/_react["default"].createElement(_inlineNotification["default"], {
    type: type,
    dismissable: false
  }, children)));
};

var _default = ToastNotification; //From: https://gist.github.com/gordonbrander/2230317

exports["default"] = _default;

var getId = function getId() {
  // Math.random should be unique because of its seeding algorithm.
  // Convert it to base 36 (numbers + letters), and grab the first 9 characters
  // after the decimal.
  return '_' + Math.random().toString(36).substr(2, 9);
}; //TODO: Fix the animation - it is not great. I'm using css to do the animation and the re-renders on the array changes causes
//a timing issue. It works perfectly, if addToast is called only once but when called multiple times before the displayed
//toast is hidden/removed it acts undesirably - which is to say the animation doesn't work because the useEffect removes
//the toast before it's animation kicks in (the opacity changes after 4.5s from the last render)


var useToast = function useToast() {
  var _useState = (0, _react.useState)([]),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      toasts = _useState2[0],
      setToasts = _useState2[1];

  var _useState3 = (0, _react.useState)([]),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      removedIds = _useState4[0],
      setRemovedIds = _useState4[1];

  var notRemoved = function notRemoved(toast) {
    return !removedIds.includes(toast.id);
  };

  (0, _react.useEffect)(function () {
    var goodToasts = toasts.filter(notRemoved);
    setToasts(goodToasts);
  }, [removedIds]);

  var ToastContainer = function ToastContainer() {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "nstyle-inline-notification--toast"
    }, toasts.map(function (toast, i) {
      var type = toast.type,
          content = toast.content;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: i === 0 ? 'animate-hidden' : ''
      }, /*#__PURE__*/_react["default"].createElement(_inlineNotification["default"], {
        key: i,
        type: type,
        dismissable: false
      }, content));
    }));
  };

  var removeToast = function removeToast(toast) {
    return function () {
      setRemovedIds([].concat((0, _toConsumableArray2["default"])(removedIds), [toast.id]));
    };
  };

  var addToast = function addToast(type, content) {
    var toast = {
      type: type,
      content: content,
      id: getId()
    };
    setToasts([].concat((0, _toConsumableArray2["default"])(toasts), [toast])); //when css animation hides it lets actually remove it from the dom

    var justBeforeAnimationIsDone = TOAST_TIMEOUT - 100;
    setTimeout(removeToast(toast), justBeforeAnimationIsDone);
  };

  return {
    addToast: addToast,
    ToastContainer: ToastContainer
  };
};

exports.useToast = useToast;